import { Injectable } from "@angular/core";
import { YousignHttpService } from "./yousign.http.service";
import { tap } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class YousignService {
  constructor(private yousignHttp: YousignHttpService) {}
  loadYousign(statementPk: number): Observable<string> {
    return this.yousignHttp.getYousignSDK().pipe(
      tap((response: any) => {
        const code = response;
        if (!code) {
          console.error("Brak kodu Yousign w odpowiedzi init");
          return;
        }
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.text = code;
        document.body.appendChild(script);
      })
    ) as Observable<string>;
  }
}
